<p-toast></p-toast>
<p-panel header="{{windowsTitle}}" *ngIf="true">
  <p-accordion [multiple]="true">

    <!-- *ngIf, not just [disabled] -- see this component's own header comment
         and EditUserAccessComponent's identical note for why: the projected
         <app-edit-*> child is instantiated (and its ngOnInit() runs) the
         instant this template renders, regardless of the parent
         p-accordionTab's disabled/selected state. *ngIf is what actually
         stops a user lacking canAccessAdminTabs from ever constructing it. -->
    <p-accordionTab *ngIf="canAccessAdminTabs" [selected]="false" cache="false">
      <ng-template pTemplate="header">
        <h5>Команда агента (Teams)</h5>
      </ng-template>
      <app-edit-agent-team-members-tab appStopAccordionHomeEnd></app-edit-agent-team-members-tab>
    </p-accordionTab>

    <p-accordionTab *ngIf="canAccessAdminTabs" [selected]="false" cache="false">
      <ng-template pTemplate="header">
        <h5>Банківські облікові дані</h5>
      </ng-template>
      <app-edit-agent-bank-credentials-tab appStopAccordionHomeEnd></app-edit-agent-bank-credentials-tab>
    </p-accordionTab>

    <p-accordionTab *ngIf="canAccessAdminTabs" [selected]="false" cache="false">
      <ng-template pTemplate="header">
        <h5>Рівні клієнтів (винятки)</h5>
      </ng-template>
      <app-edit-agent-customer-tier-list-tab appStopAccordionHomeEnd></app-edit-agent-customer-tier-list-tab>
    </p-accordionTab>

    <p-accordionTab [selected]="false" [disabled]="!canManageBlockedCounterparties" cache="false">
      <ng-template pTemplate="header">
        <h5>Заблоковані контрагенти (банк)</h5>
      </ng-template>
      <app-edit-agent-bank-blocked-counterparties-tab appStopAccordionHomeEnd></app-edit-agent-bank-blocked-counterparties-tab>
    </p-accordionTab>
  </p-accordion>
</p-panel>
